import { Routes, Route } from 'react-router-dom';
// import Loadable from 'react-loadable';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';

const AgentSearchForm = loadable(() => import('./agentSearch/AgentSearchForm'), { fallback: null });
const Broker = loadable(() => import('./brokerLists/Index'), { fallback: null });
const HearderSearchPartner = loadable(() => import('./components/layout/Header'), { fallback: null });
const FooterSearchPartner = loadable(() => import('./components/layout/Footer'), { fallback: null });

const liffId = config.liff_id.searchPartner;

function SearchPartner() {
	return (
		<>
			<HearderSearchPartner />
			<div className="site-body content-wrapper" id="page">
				<Routes>
					<Route
						path="agent"
						element={<AuthProvider liffId={liffId} allowGuest><AgentSearchForm /></AuthProvider>}
					/>
					<Route path="broker" element={<Broker />} />
				</Routes>
			</div>
			<FooterSearchPartner />
		</>
	);
}

export default SearchPartner;
